const theme = {
    isBuiltIn: true,
    id: "daybreak",
    name: "Daybreak",
    cjkFont: "jp",
    colors: {
        accent1: "rgba(255,217,173,1)",
        accent2: "rgba(254,192,136,1)",
        accent3: "rgba(253,134,77,1)",
        accent4: "rgba(255,128,0,1)",
        accent5: "rgba(255,121,122,1)",
        background_accent: "rgba(34,34,34,1)",
        background_dark: "rgba(0,0,0,1)",
        background_light: "rgba(255,255,255,1)",
        chart1: "rgba(0,68,255,1)",
        chart2: "rgba(34,170,238,1)",
        chart3: "rgba(255,217,173,1)",
        chart4: "rgba(253,134,77,1)",
        chart5: "rgba(255,128,0,1)",
        chart6: "rgba(255,121,122,1)",
        hyperlink: "rgba(19,156,229,1)",
        negative: "rgba(255,121,122,1)",
        positive: "rgba(161,202,85,1)",
        primary_dark: "rgba(51,51,51,1)",
        primary_light: "rgba(255,255,255,1)",
        secondary_dark: "rgba(0,0,0,0.55)",
        secondary_light: "rgba(255,255,255,0.8)",
        theme: "rgba(34,170,238,1)"
    },
    defaultBackgroundColor: "background_dark",
    defaultSlideColor: "theme",
    fontBodyFontId: "inter",
    fontBodyLetterSpacing: -0.02,
    fontBodyLineHeight: 1.9,
    fontBodyScaling: 100,
    fontBodyTextTransform: "auto",
    fontBodyWeight: 500,
    fontHeaderFontId: "inter",
    fontHeaderLetterSpacing: -0.06,
    fontHeaderLineHeight: 1.6,
    fontHeaderScaling: 100,
    fontHeaderTextTransform: "auto",
    fontHeaderWeight: 600,
    fontScale: 1,
    fontTitleFontId: "inter",
    fontTitleLetterSpacing: -0.06,
    fontTitleLineHeight: 1.6,
    fontTitleScaling: 100,
    fontTitleTextTransform: "auto",
    fontTitleWeight: 600,
    footerMessage: `${new Date().getFullYear()} Proprietary and Confidential. All Rights Reserved.`,
    iconStyle: "classic",
    isRTL: false,
    logoOffset: 0,
    logoPosition: "left",
    logoScale: 1,
    palette_name: "custom",
    showFooterByDefault: true,
    showLogo: true,
    showMessage: false,
    showPageNum: true,
    styleBackground: "none",
    styleBodyFont: "sourcesanspro",
    styleDecoration: "none_center",
    styleDesign: 1,
    styleEffect: "none",
    styleElementStyle: "filled",
    styleFontWeight: "heavy",
    styleShape: "circle",
    styleTitleFont: "bebasneue",
    styleTitleSlide: "bar_left",
    styleWeight: "medium"
};

module.exports = theme;
